var $ = jQuery

$(document).ready(function($){
    $(window).trigger('resize');

    $('.fb-carousel').each(function () {
        var navPrev = $(this).parent().find('.carousel-nav .prev');
        var navNext = $(this).parent().find('.carousel-nav .next');
        $(this).slick({
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            prevArrow: navPrev,
            nextArrow: navNext,
            // centerMode : true,
            // centerPadding: '15px',
        });
    });

    // $( ".content:contains('#')" ).css( "text-decoration", "underline" );

    $('.target-lightbox').each(function() {
			var galleryItems = $(this);

			galleryItems.lightGallery({
				selector: '.item',
				download:false,
				fullScreen: false,
				pager: false,
				zoom: false,
				hash: false,
				loop:false,
				slideEndAnimatoin: false,
				hideControlOnEnd: true,
				showThumbByDefault: false,
				exThumbImage: 'data-src',
				currentPagerPosition: 'middle',
				autoplayControls: true,
				progressBar: true,
				share:false,
				twitter:false,
				googlePlus: false,
				pinterest: false,
			});
	});

    $('.btn-target').on('click', function(){
        var targetImg = $(this).parent().find('.target-lightbox li');
        var dataSrc = targetImg.data('src');
        console.log(dataSrc);
        $(this).parent().find('.target-lightbox .item:first-of-type').click();
    });

    // SWITCHER
    $('.switcher .btn-switch').on('click', function(e){
        e.preventDefault();
        $('.btn-switch').removeClass('active');
        $(this).addClass('active');
        $('.fb-carousel').trigger('refresh.owl.carousel');
    });

    // FACEBOOK Switcher
    $('.btn-switch.fb').on('click', function(e){
        e.preventDefault();
        $('[data-network="instagram"]').addClass('d-none');
        $('[data-network="instagram-stories"]').addClass('d-none');
        $('[data-network="linkedin"]').addClass('d-none');
        $('[data-network="facebook"]').removeClass('d-none');
    });

    // INSTAGRAM Switcher
    $('.btn-switch.ig').on('click', function(e){
        e.preventDefault();
        $('[data-network="facebook"]').addClass('d-none');
        $('[data-network="instagram-stories"]').addClass('d-none');
        $('[data-network="linkedin"]').addClass('d-none');
        $('[data-network="instagram"]').removeClass('d-none');
        $('.ig-carousel').each(function () {
            var dotsNav = $(this).parent().parent().parent().find('.social-actions .user-actions .dots-nav');
            $(this).slick({
                // slidesToShow: 1,
                arrows: false,
                dots: true,
                appendDots: dotsNav,
                infinite: false,
            });
        });
    });

    // INSTAGRAM Switcher
    $('.btn-switch.ig-stories').on('click', function(e){
        e.preventDefault();
        $('[data-network="facebook"]').addClass('d-none');
        $('[data-network="instagram"]').addClass('d-none');
        $('[data-network="linkedin"]').addClass('d-none');
        $('[data-network="instagram-stories"]').removeClass('d-none');
    });

    // LINKEDIN Switcher
    $('.btn-switch.in').on('click', function(e){
        e.preventDefault();
        $('[data-network="facebook"]').addClass('d-none');
        $('[data-network="instagram-stories"]').addClass('d-none');
        $('[data-network="instagram"]').addClass('d-none');
        $('[data-network="linkedin"]').removeClass('d-none');
        $('.in-carousel').each(function () {
            var navPrev = $(this).parent().find('.carousel-nav .prev');
            var navNext = $(this).parent().find('.carousel-nav .next');
            $(this).slick({
                slidesToShow: 1,
                centerMode: true,
                variableWidth: true,
                prevArrow: navPrev,
                nextArrow: navNext,
                // centerMode : true,
                // centerPadding: '15px',
            });
        });
    });

    $('.fb-post .col.content').each(function(index, el) {
        $(this).html($(this).html().replace(/(^|\W)#(\w+)/g, function(_, $1, $2) { return $1 + " <span class='fb-hash'>" + "#" + $2 + "</span>"  }));
        $(this).html($(this).html().replace(/(^|\W)@(\w+)/g, function(_, $1, $2) { return $1 + " <span class='fb-at'>"+ "@"+ $2 + "</span>"  }));
    });

    $('.ig-post .post-content').each(function(index, el) {
        $(this).html($(this).html().replace(/(^|\W)#(\w+)/g, function(_, $1, $2) { return $1 + " <span class='ig-hash'>" + "#" + $2 + "</span>"  }));
        $(this).html($(this).html().replace(/(^|\W)@(\w+)/g, function(_, $1, $2) { return $1 + " <span class='ig-at'>" + "@" + $2 + "</span>"  }));
    });

    $('.in-post .post-content').each(function(index, el) {
        $(this).html($(this).html().replace(/(^|\W)#(\w+)/g, function(_, $1, $2) { return $1 + " <span class='in-hash'>" + "#" + $2 + "</span>"  }));
        $(this).html($(this).html().replace(/(^|\W)@(\w+)/g, function(_, $1, $2) { return $1 + " <span class='in-at'>" + "@" + $2 + "</span>"  }));
    });

    // Select ON Change
    if($('#controls #date')){
        var currentUrl = window.location.href;
        var url = new URL(currentUrl);
        var period = url.searchParams.get('period');
        if(period){
            $('#controls #date option[value="'+period+'"]').attr("selected", "selected");        
        }
        else{
            $('#controls #date option[value="default"]').attr("selected", "selected");        
        }
        var option = $('#controls #date option[selected]').val();
        var plan = $('#controls #related-plans li');

        plan.each(function(){
            $(this).addClass('d-none');
            $('#controls #related-plans [data-time="'+option+'"]').removeClass('d-none');
                
            // ⚠️ Active below lines for Debug
            // $(this).removeClass('active');
            // $('#controls #related-plans [data-time="'+option+'"]').addClass('d-none');
        });
    
        $(document).on('change', 'select', function(e){
            var value = e.target.value;
            $('#controls #date option').removeAttr("selected");
            $('#controls #date option[value="' + value + '"]').attr("selected", "selected");

            plan.each(function(){
                $(this).addClass('d-none');
                $('#controls #related-plans [data-time="'+value+'"]').removeClass('d-none');

                // ⚠️ Active below lines for Debug
                // $('#controls #related-plans li').removeClass('active');
                // $('#controls #related-plans [data-time="'+value+'"]').addClass('active');
            });
            if($('#date option[selected]').val() != "default"){
                $('#related-plans .related').removeClass('d-none');
            }
        });
    } 
    if($('#date option[selected]').val() != "default"){
        $('#related-plans .related').removeClass('d-none');
    }
        
});

// $(window).on('load', function(){
//     $('.fb-carousel').each(function () {
//         $(this).slick({
//             infinite : false,
//         });
//     });
// });
//commento
